import { Box } from '@mui/material';
import styled from 'styled-components';

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 960px;
  margin: 0 auto;
  padding: 8px 0 40px;

  .sort-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const Toolbar = styled(Box)`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 800px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Actions = styled(Box)`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
`;

export const StatusBadge = styled(Box)<{ $hasChanges: boolean }>`
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 7px 10px;
  border-radius: 999px;
  color: ${({ $hasChanges }) => ($hasChanges ? '#9a6700' : '#2e7d32')};
  background: ${({ $hasChanges }) => ($hasChanges ? '#fff8e1' : '#edf7ed')};
  font-size: 13px;
  font-weight: 600;
`;

export const SortCard = styled(Box)`
  position: relative;
  display: flex;
  gap: 16px;
  align-items: center;
  min-height: 88px;
  padding: 12px 16px;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.04);
  cursor: grab;
  user-select: none;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;

  &:hover {
    border-color: #b8c2d0;
    box-shadow: 0 6px 18px rgba(16, 24, 40, 0.08);
  }

  &:active {
    cursor: grabbing;
  }

  &.dragged {
    border-color: #1976d2;
    box-shadow: 0 12px 30px rgba(25, 118, 210, 0.18);
    cursor: grabbing;
    transform: rotate(0.5deg);
  }

  .drag-handle {
    color: #98a2b3;
    flex-shrink: 0;
  }

  @media (max-width: 600px) {
    gap: 10px;
    padding: 10px;
  }
`;

export const OrderNumber = styled(Box)`
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  color: #344054;
  background: #f2f4f7;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
`;

export const MemberImage = styled('img')`
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  background: #f8fafc;
  object-fit: cover;
  flex-shrink: 0;

  @media (max-width: 600px) {
    width: 52px;
    height: 52px;
  }
`;

export const EmptyState = styled(Box)`
  display: flex;
  min-height: 260px;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d0d5dd;
  border-radius: 16px;
  background: #fafbfc;
  text-align: center;
`;
